import { gql } from '@root/gql/utils/gql';

export const getVouchersQuery = gql`
  query GetVouchers($dto: GetVouchersDto!) {
    vouchers(dto: $dto) {
      data {
        categoryIds
        createdAt
        deletedAt
        additionalContent
        id
        images {
          imageUrl
          priority
        }
        isPublished
        language
        mainImageUrl
        name
        offerPrice {
          discountedPrice
          discountName
          fullPrice
        }
        onlyByUri
        options {
          createdAt
          deletedAt
          id
          language
          name
          offerPrice {
            discountedPrice
            discountName
            fullPrice
          }
          price
          updatedAt
        }
        stock {
          optionStock {
            quantity
            optionId
          }
          productStock {
            quantity
          }
        }
        price
        purchaseLimit
        settings {
          createdAt
          deletedAt
          id
          productId
          productLevelQuantity
          quantityLevelSetting
          redemptionValidityPeriodMonths
          salesGeneratedByThirdParties
          updatedAt
        }
        briefDescription
        termsAndConditions
        type
        updatedAt
      }
      meta {
        currentPage
        finalPage
        limitPerPage
        total
      }
    }
  }
`;
